module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-2021-4.9c206413.jpg";